// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__rAk54","spin":"Loader_spin__TU67e","sm":"Loader_sm__THuyf","md":"Loader_md__wvix2","lg":"Loader_lg__8IwvV"};